import { useCallback as l } from "react";
function w(c) {
  const u = l((e, r) => {
    if (!e)
      return;
    const n = Array.from(e.querySelectorAll("a, button")), t = n.indexOf(document.activeElement), a = r === "next" ? t + 1 : t - 1, o = n[a];
    o && o.focus();
  }, []);
  return { handleKeyDown: l(
    (e, r) => {
      var o, s, i, f, b, d;
      const n = ((o = c.current) == null ? void 0 : o[r]) || null, t = (s = c.current) == null ? void 0 : s[r - 1], a = (i = c.current) == null ? void 0 : i[r + 1];
      switch (e.key) {
        case "ArrowRight":
          e.preventDefault(), (f = a == null ? void 0 : a.querySelector("a, button")) == null || f.focus();
          break;
        case "ArrowLeft":
          e.preventDefault(), (b = t == null ? void 0 : t.querySelector('a[aria-expanded="true"], button[aria-expanded="true"]')) == null || b.focus();
          break;
        case "Escape":
          e.preventDefault(), (d = t == null ? void 0 : t.querySelector("button")) == null || d.focus();
          break;
        case "ArrowDown":
          e.preventDefault(), u(n, "next");
          break;
        case "ArrowUp":
          e.preventDefault(), u(n, "prev");
          break;
      }
    },
    [c, u]
  ) };
}
export {
  w as useNavigationKeyboard
};
